import _objectSpread from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { searchTasks, searchTaskLogs, saveTask, deleteTask, triggerTask, pauseTask, resumeTask } from '@api/u8.api.task';
import util from '@/libs/util';
import cron from '../../components/cron';
import HelperBox from '../../components/u8.helper.box';
import AlarmList from './components/alarm.config';
export default {
  data: function data() {
    return {
      data: [],
      loading: false,
      logLoading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      logPagination: {
        currentPage: 1,
        pageSize: 8,
        total: 0
      },
      dialogFormVisible: false,
      showCronBox: false,
      currMaxTimeUnit: 'hour',
      form: {
        id: '0',
        taskID: '',
        taskName: '',
        taskClass: '',
        taskGroup: '',
        taskExpression: '',
        taskDescription: '',
        taskParams: '',
        taskBeginTime: '',
        misfireType: '0',
        maxTimeSecs: ''
      },
      detailForm: {
        id: '0',
        taskID: '',
        taskName: '',
        taskClass: '',
        taskGroup: '',
        taskExpression: '',
        taskDescription: '',
        taskParams: '',
        startTime: '',
        misfireType: '0'
      },
      alarmInfo: {
        taskID: 0,
        taskUniID: 2
      },
      taskLogs: [],
      gameIconUrl: '',
      currCpName: '',
      formSearch: {
        name: '',
        cpID: '',
        appID: '',
        isSingle: ''
      },
      rules: {
        taskName: [{
          required: true,
          message: '请输入任务名称',
          trigger: 'blur'
        }],
        taskClass: [{
          required: true,
          message: '请输入任务脚本类',
          trigger: 'blur'
        }],
        taskGroup: [{
          required: true,
          message: '请选择任务分组',
          trigger: 'blur'
        }],
        taskExpression: [{
          required: true,
          message: '请选择任务表达式',
          trigger: 'blur'
        }]
      },
      currDetailRow: {},
      dialogWidth: '50%',
      formLabelWidth: '120px',
      dialogTitle: '添加任务',
      currSelectedRows: [],
      isShowDetail: false,
      drawerDirection: 'rtl',
      isFromEdit: false,
      alarmDialogVisible: false,
      alarmDialogWidth: '60%',
      alarmTitle: '告警配置列表'
    };
  },
  components: {
    cron: cron,
    HelperBox: HelperBox,
    AlarmList: AlarmList
  },
  mounted: function mounted() {
    this.dialogWidth = this.$ajustDialogWidth();
    this.alarmDialogWidth = this.$ajustBaseWidth(60);
    this.fetchData(true);
  },
  filters: {
    ellipsis: function ellipsis(value) {
      if (!value) return '';

      if (value.length > 100) {
        return value.slice(0, 100) + '...';
      }

      return value;
    }
  },
  methods: {
    getPageItemNum: function getPageItemNum() {
      //获取当前表格页中有多少条记录
      var totalPageNum = Math.ceil(this.pagination.total / this.pagination.pageSize);

      if (this.pagination.currentPage == totalPageNum) {
        //最后一页
        return this.pagination.total % this.pagination.pageSize;
      }

      return this.pagination.pageSize;
    },
    onSearchSubmit: function onSearchSubmit() {
      //查询框按钮点击，或者查询条件文本输入触发查询
      this.fetchData(true);
    },
    onSearchReset: function onSearchReset() {
      //查询重置表单按钮点击，重置表单
      this.$refs['formSearch'].resetFields();
      this.fetchData(true);
    },
    handleSizeChange: function handleSizeChange(currPageSize) {
      this.pagination.pageSize = currPageSize;
      this.fetchData(true);
    },
    paginationCurrentChange: function paginationCurrentChange(currentPage) {
      //分页事件
      this.pagination.currentPage = currentPage;
      this.fetchData(false);
    },
    logPaginationCurrentChange: function logPaginationCurrentChange(currentPage) {
      this.logPagination.currentPage = currentPage;
      this.fetchTaskLogs(this.detailForm.id);
    },
    handleSelectionChange: function handleSelectionChange(selection) {
      //多选事件
      this.currSelectedRows = selection;
    },
    refreshRows: function refreshRows() {
      this.fetchData(false);
    },
    fetchData: function fetchData(resetPage) {
      var _this = this;

      //从服务器端拉取数据，resetPage为true，说明重置分页到第一页；resetPage为false，停留在当前页
      this.loading = true;

      if (resetPage) {
        this.pagination.currentPage = 1;
      }

      searchTasks(_objectSpread(_objectSpread({}, this.pagination), this.formSearch)).then(function (res) {
        _this.data = res.records;
        _this.pagination.total = Number(res.total);
        _this.loading = false;
      }).catch(function (err) {
        console.log('err', err);
        _this.loading = false;
      });
    },
    fetchTaskLogs: function fetchTaskLogs(taskID) {
      var _this2 = this;

      this.logLoading = true;
      searchTaskLogs(_objectSpread({
        "taskID": taskID
      }, this.logPagination)).then(function (res) {
        _this2.taskLogs = res.records;
        _this2.logPagination.total = Number(res.total);
        _this2.logLoading = false;
      }).catch(function (err) {
        _this2.logLoading = false;
        console.log('err', err);
      });
    },
    addRow: function addRow() {
      //添加一条新记录
      this.isFromEdit = false;
      this.dialogTitle = "添加任务";

      if (this.$refs['form']) {
        this.$refs['form'].resetFields();
        this.$refs['form'].clearValidate();
      }

      Object.assign(this.form, this.$options.data().form);
      this.dialogFormVisible = true;
    },
    editRow: function editRow(index, row) {
      //编辑当前记录
      this.isFromEdit = true;
      this.dialogTitle = "编辑任务";

      if (this.$refs['form']) {
        this.$refs['form'].clearValidate();
      }

      this.form = Object.assign({}, row);
      this.form.misfireType = this.form.misfireType + '';
      this.currMaxTimeUnit = 'sec';
      this.form.taskBeginTime = row.startTime;
      this.dialogFormVisible = true;
    },
    getMaxTimeInSecs: function getMaxTimeInSecs() {
      var currVal = this.form.maxTimeSecs;

      if (this.currMaxTimeUnit == "hour") {
        currVal = currVal * 3600;
      } else if (this.currMaxTimeUnit == 'min') {
        currVal = currVal * 60;
      }

      return currVal;
    },
    handleMaxTimeCommand: function handleMaxTimeCommand(command) {
      this.currMaxTimeUnit = command;
    },
    showDetail: function showDetail(index, row) {
      //展示详情
      this.fetchTaskLogs(row.id);
      this.detailForm = Object.assign({}, row);
      this.detailForm.misfireType = this.detailForm.misfireType + '';
      this.isShowDetail = true;
    },
    showAlarms: function showAlarms(index, row) {
      var _this3 = this;

      this.alarmInfo.taskID = row.id;
      this.alarmInfo.taskUniID = row.taskID;
      this.alarmTitle = "[" + row.taskName + "]";
      this.alarmDialogVisible = true;
      this.$nextTick(function () {
        if (_this3.$refs['alarms']) {
          _this3.$refs['alarms'].fetchData();
        }
      });
    },
    addAlarm: function addAlarm() {
      if (this.$refs['alarms']) {
        this.$refs['alarms'].addAlarm();
      }
    },
    triggerRow: function triggerRow(index, row) {
      var _this4 = this;

      this.$confirm('您确定要立即触发该任务吗?', '触发确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        triggerTask({
          "taskID": row.id
        }).then(function (res) {
          _this4.$message({
            type: 'success',
            message: '触发成功'
          });

          _this4.fetchData(false);
        }).catch(function (err) {
          console.log('err', err);
        });
      }).catch(function () {
        _this4.$message({
          type: 'warning',
          message: '取消触发'
        });
      });
    },
    pauseRow: function pauseRow(index, row) {
      var _this5 = this;

      this.$confirm('您确定要暂停该任务吗?', '暂停确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        pauseTask({
          "taskID": row.id
        }).then(function (res) {
          _this5.$message({
            type: 'success',
            message: '暂停成功'
          });

          _this5.fetchData(false);
        }).catch(function (err) {
          console.log('err', err);
        });
      }).catch(function () {
        _this5.$message({
          type: 'warning',
          message: '取消暂停'
        });
      });
    },
    resumeRow: function resumeRow(index, row) {
      var _this6 = this;

      this.$confirm('您确定要恢复该任务吗?', '恢复确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        resumeTask({
          "taskID": row.id
        }).then(function (res) {
          _this6.$message({
            type: 'success',
            message: '恢复成功'
          });

          _this6.fetchData(false);
        }).catch(function (err) {
          console.log('err', err);
        });
      }).catch(function () {
        _this6.$message({
          type: 'warning',
          message: '取消恢复'
        });
      });
    },
    deleteRow: function deleteRow(index, row) {
      var _this7 = this;

      //删除当前记录
      this.$confirm('您确定要删除该任务吗?', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'u8-style-delete'
      }).then(function () {
        deleteTask({
          "taskID": row.id
        }).then(function (res) {
          _this7.$message({
            type: 'success',
            message: '删除成功'
          });

          if (_this7.getPageItemNum() <= 1) {
            _this7.fetchData(true);
          } else {
            _this7.fetchData(false);
          }
        }).catch(function (err) {
          console.log('err', err);
        });
      }).catch(function () {
        _this7.$message({
          type: 'warning',
          message: '取消删除'
        });
      });
    },
    deleteRows: function deleteRows() {
      var _this8 = this;

      //删除选中的所有记录
      if (this.currSelectedRows.length == 0) {
        this.$message({
          message: '请选择要删除的记录',
          type: 'warning'
        });
        return;
      }

      this.$confirm('确定要删除选中的所有记录吗?', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'u8-style-delete'
      }).then(function () {
        var ids = _this8.currSelectedRows.map(function (item) {
          return item.appID;
        }).join(',');

        deleteMultiGames({
          "ids": ids
        }).then(function (res) {
          _this8.$message({
            type: 'success',
            message: '删除成功'
          });

          if (_this8.getPageItemNum() <= _this8.currSelectedRows.length) {
            _this8.fetchData(true);
          } else {
            _this8.fetchData(false);
          }
        }).catch(function (err) {
          console.log('err', err);
        });
      }).catch(function () {
        _this8.$message({
          type: 'warning',
          message: '取消删除'
        });
      });
    },
    submitForm: function submitForm(formName) {
      var _this9 = this;

      //添加或者编辑表单提交
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this9.form.maxTimeSecs = _this9.getMaxTimeInSecs();
          saveTask(_objectSpread({}, _this9.form)).then(function (res) {
            _this9.dialogFormVisible = false;

            _this9.$message({
              message: '操作成功',
              type: 'success'
            });

            if (_this9.isFromEdit) {
              _this9.fetchData(false);
            } else {
              _this9.fetchData(true);
            }
          }).catch(function (err) {
            console.log('err', err);
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      //添加或者编辑表单，清理表单数据
      this.dialogFormVisible = false;

      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
        this.$refs[formName].clearValidate();
      } else {
        console.log("the form is not exists." + formName);
      }
    }
  }
};